export default __webpack_public_path__ + "static/media/13.662e8a5b.png";